import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import './not-found.css'

const NotFound = (props) => {
  return (
    <main className="not-found-container">
      <SEO
        title="404 - Sayfa Bulunamadı | ATEŞ AUTO DETAILING"
        description="Aradığınız sayfa taşınmış veya mevcut değil. Ana sayfaya dönerek araç koruma ve detailing hizmetlerimizi inceleyebilirsiniz."
        noindex={true}
      />
      <h1 className="not-found-text1">404</h1>
      <h2 className="not-found-text2">Sayfa Bulunamadı</h2>
      <p className="not-found-text3">
        Aradığınız sayfa taşınmış, adı değişmiş veya yayından kaldırılmış olabilir.
        Ana sayfaya dönerek stüdyo hizmetlerimizi inceleyebilir veya bizimle iletişime geçebilirsiniz.
      </p>
      <Link to="/" className="not-found-a">
        Ana Sayfaya Dön
      </Link>
    </main>
  )
}

export default NotFound
